export { HeroSlider } from './HeroSlider';
